export default "__VITE_ASSET__932295c6__"